import { createFeatureSelector, createSelector } from '@ngrx/store';
import { COUNTRY_TERRITORIES_FEATURE_KEY } from './country-territories.reducer';
import { CountryAndTerritoriesState } from '@cpak/interfaces';

// Lookup the 'CountriesTerritories' feature state managed by NgRx
export const countriesTerritoriesFeatureSelector = createFeatureSelector<CountryAndTerritoriesState>(
  COUNTRY_TERRITORIES_FEATURE_KEY
);

// eslint-disable-next-line
export const getCountriesTerritoriesState = () =>
  createSelector(countriesTerritoriesFeatureSelector, (state: CountryAndTerritoriesState) => state);

// eslint-disable-next-line
export const getSelectedCountries = () =>
  createSelector(countriesTerritoriesFeatureSelector, (state: CountryAndTerritoriesState) => state.country);

// eslint-disable-next-line
export const getSelectedTerritories = () =>
  createSelector(
    countriesTerritoriesFeatureSelector,
    ({ territories, allTerritories }: CountryAndTerritoriesState) => ({ territories, allTerritories })
  );
